import { Renderer2, ElementRef } from '@angular/core';
import * as i0 from "@angular/core";
export class LoaderService {
    constructor() { }
    setElementRef(el) {
        this.elementRef = el;
    }
    hideLoadingSpinner() {
        this.renderer.setStyle(this.elementRef.nativeElement.querySelector('.bil-loading-screen'), 'z-index', -1);
    }
    showLoadingSpinner() {
        this.renderer.setStyle(this.elementRef.nativeElement.querySelector('.bil-loading-screen'), 'visibility', 'visible');
        this.renderer.setStyle(this.elementRef.nativeElement.querySelector('.bil-loading-screen'), 'z-index', 999999);
    }
}
LoaderService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoaderService_Factory() { return new LoaderService(); }, token: LoaderService, providedIn: "root" });
